import {
    Breadcrumbs,
    ProductsNav,
    BrandingVideoItem,
    BrandingPresentationItem,
} from "@hatch-digital-nl/bravilor-storybook";
import { JSX, useEffect } from "react";
import { RouteEnum } from "../../common/enums/RouteEnum";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
    BrandingTypeEnum,
    setBrandingType,
    setBrandingItems,
} from "./BrandingSlice";
import { useLocalData } from "../../common/hooks/useLocalData";
import { BrandingInterface } from "../../common/interfaces/BrandingInterface";
import { BrandingPdfItemSkeleton } from "../../common/components/branding/brandingPdfItemSkeleton";
import { BrandingVideoItemSkeleton } from "../../common/components/branding/brandingVideoItemSkeleton";
import { getFileTypeFromUrl } from "../../common/utils/getFileTypeFromUrl";

const BrandingPageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { branding, getLocalBrandingFileUrl, isLoading } = useLocalData();
    const {
        brandingItems,
        brandingImages,
        brandingThumbnails,
        brandingType,
        isProcessingBrandingItems,
    } = useAppSelector((state) => state.branding);

    useEffect(() => {
        dispatch(
            setBrandingItems({
                brandingItems: branding,
                brandingType,
                getLocalBrandingFileUrl,
            }),
        );
    }, [branding, brandingType, dispatch, getLocalBrandingFileUrl]);

    const breadcrumbItems = [
        {
            label: "Branding",
            link: RouteEnum.BRANDING,
            to: RouteEnum.BRANDING,
        },
        {
            label:
                brandingType === BrandingTypeEnum.VIDEOS
                    ? "Videos"
                    : "Presentations",
            to: RouteEnum.BRANDING,
        },
    ];

    const brandingNavItems = [
        {
            type: BrandingTypeEnum.VIDEOS,
            text: "Videos",
            panelId: "videos",
        },
        {
            type: BrandingTypeEnum.PRESENTATIONS,
            text: "Presentations",
            panelId: "presentations",
        },
    ];

    return (
        <div className="p-branding">
            <div className="p-branding__header">
                <Breadcrumbs items={breadcrumbItems} />
            </div>

            <div className="p-branding__content">
                <div className="p-branding__content__nav">
                    <ProductsNav
                        activeProductType={brandingType}
                        onProductTypeChange={(type: string) =>
                            dispatch(setBrandingType(type as BrandingTypeEnum))
                        }
                        isLoadingTranslations={false}
                        navItems={brandingNavItems}
                    />
                </div>

                <div className="p-branding__content__items">
                    {isLoading || isProcessingBrandingItems ? (
                        brandingType === BrandingTypeEnum.VIDEOS ? (
                            <BrandingVideoItemSkeleton />
                        ) : (
                            <BrandingPdfItemSkeleton />
                        )
                    ) : (
                        brandingItems.map((item: BrandingInterface) => {
                            const brandingItem = {
                                ...item,
                                mainUrl: brandingImages[item.id],
                                thumbnailUrl: brandingThumbnails[item.id],
                            };

                            if (brandingItem.type === BrandingTypeEnum.VIDEOS) {
                                return (
                                    <BrandingVideoItem
                                        key={item.id}
                                        brandingItem={brandingItem}
                                    />
                                );
                            }

                            if (
                                brandingItem.type ===
                                BrandingTypeEnum.PRESENTATIONS
                            ) {
                                return (
                                    <BrandingPresentationItem
                                        key={item.id}
                                        brandingItem={brandingItem}
                                        fileType={getFileTypeFromUrl(
                                            item.mainUrl,
                                        )}
                                    />
                                );
                            }

                            return null;
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default BrandingPageContainer;
